// extracted by mini-css-extract-plugin
export var quillEditor = "_o7-1";
export var variable = "_o7-0";